import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Space,
  Switch,
  Table,
  Typography,
  Select,
} from "antd";
import React, { useEffect, useState, useReducer } from "react";
import MasterDataService from "../../services/masterdata.service";
import { createAction, createReducer } from "@reduxjs/toolkit";
import _ from "lodash";

const { confirm } = Modal;
const { Paragraph } = Typography;
const setLoading = createAction("SET_LOADING");
const setOpenModal = createAction("SET_OPEN_MODAL");
const setCloseModal = createAction("SET_CLOSE_MODAL");
const setData = createAction("SET_DATA");
const setSaving = createAction("SET_SAVING");
const setSearchValue = createAction("SET_SEARCH_VALUE");

const initState = {
  loading: false,
  search: {
    project_type: "h",
  },
  dataSorce: [],
  modal: {
    visible: false,
    data: null,
    selectedKey: null,
  },
  saving: false,
};

const reducer = createReducer(initState, (builder) => {
  builder.addCase(setLoading, (state, { payload }) => {
    state.loading = payload;
  });

  builder.addCase(setOpenModal, (state, { payload }) => {
    state.modal.visible = true;
    state.modal.data = payload?.data ? payload.data : null;
    state.modal.selectedKey = payload?.key ? payload.key : null;
  });

  builder.addCase(setCloseModal, (state) => {
    state.modal.visible = false;
    state.modal.data = null;
    state.modal.selectedKey = null;
  });

  builder.addCase(setData, (state, { payload }) => {
    state.dataSorce = payload;
  });

  builder.addCase(setSaving, (state, { payload }) => {
    state.saving = payload;
  });

  builder.addCase(setSearchValue, (state, { payload }) => {
    state.search = { ...state.search, ...payload };
  });
});

function TableMyHomeMenu({ id }) {
  // state table
  const [state, dispatch] = useReducer(reducer, initState);
  // const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalMultiStatus, setModalMultiStatus] = useState(false);
  const [modalCreateServiceMenu, setModalCreateServiceMenu] = useState(false);
  const [modalEditServiceMenu, setModalEditServiceMenu] = useState({
    visible: false,
    id: "",
    name_th: "",
    name_en: "",
    alias: "",
    url: "",
    logo: "",
    is_pm: true,
    is_rem: true,
    is_rental: true,
    seq: 0,
  });
  const [statusValue, setStatusValue] = useState("Active");

  // fetch data
  const fetch = async (params = { page: 1, pageSize: 10 }) => {
    try {
      setLoading(true);
      const ret = await MasterDataService.getMyHomeServiceMenu(id);
      // check rem error
      if (ret.status !== 200) {
        throw { message: ret.data.message };
      }

      const data = _.orderBy(ret.data, "seq");
      setLoading(false);
      dispatch({ type: "SET_DATA", payload: data });
    } catch (error) {
      return;
    }
  };

  const showConfirmStatus = (id, status) => {
    let dataValue = {
      id: id,
      status: status === "Active" ? "Deactive" : "Active",
    };
    confirm({
      title: "Comfirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure to change status?",
      onOk() {
        MasterDataService.updateStatusMyHomeServiceMenu(dataValue)
          .then((data) => {
            setLoading(true);
            openNotificationWithIcon("success");
            fetch();
            return new Promise((resolve, reject) => {
              setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            }).catch(() => console.log("Oops errors!"));
          })
          .catch((err) => {
            openNotificationWithIcon("error");
            console.log("Oops errors!");
          });
      },
      onCancel() {},
    });
  };
  const showConfirmDelete = (id, status) => {
    let dataValue = {
      id: id,
      status: status === "Active" ? "Deactive" : "Active",
    };
    confirm({
      title: "Comfirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure to change status?",
      onOk() {
        MasterDataService.deleteMyHomeServiceMenu(dataValue)
          .then((data) => {
            setLoading(true);
            openNotificationWithIcon("success");
            fetch();
            return new Promise((resolve, reject) => {
              setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            }).catch(() => console.log("Oops errors!"));
          })
          .catch((err) => {
            openNotificationWithIcon("error");
            console.log("Oops errors!");
          });
      },
      onCancel() {},
    });
  };

  const onSelectChange = (selectedRowKeys) => {
    //console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeStatus = (e) => {
    console.log("radio checked", e.target.value);
    setStatusValue(e.target.value);
  };

  const CollectionStatusForm = ({ visible, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={visible}
        title="Change Status"
        okText="Save"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          onCreate();
        }}
      >
        <Radio.Group onChange={onChangeStatus} value={statusValue}>
          <Radio value={"Active"}>Active</Radio>
          <Radio value={"Deactive"}>Deactive</Radio>
        </Radio.Group>
      </Modal>
    );
  };

  const onSubmitStatus = () => {
    let dataValue = {
      Id: selectedRowKeys,
      Status: statusValue,
    };
    MasterDataService.updateStatusMyHomeServiceMenu(dataValue)
      .then((data) => {
        setLoading(true);
        openNotificationWithIcon("success");
        setModalMultiStatus(false);
        setSelectedRowKeys([]);
        fetch();
      })
      .catch((err) => {
        openNotificationWithIcon("error");
        console.log("Oops errors!");
      });
  };

  const CollectionCreateServiceMenuForm = ({ visible, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={visible}
        title="Create a new LINE OA My Home Service"
        okText="Create"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{
            Select: "",
          }}
        >
          <Form.Item
            name="name_th"
            label="Name TH"
            rules={[
              {
                required: true,
                message: "Please input the Name TH!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="name_en"
            label="Name EN"
            rules={[
              {
                required: true,
                message: "Please input the Name EN!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="alias"
            label="Alias"
            rules={[
              {
                required: true,
                message: "Please input the Alias!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="url"
            label="Url"
            rules={[
              {
                required: true,
                message: "Please input the Url!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="logo"
            label="Logo"
            rules={[
              {
                required: true,
                message: "Please input the Logo!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Is REM"
            name="is_rem"
            rules={[
              {
                required: true,
                message: "Please input the REM!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Is PM"
            name="is_pm"
            rules={[
              {
                required: true,
                message: "Please input the PM!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Is Rental"
            name="is_rental"
            rules={[
              {
                required: true,
                message: "Please input the Rental!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="seq"
            label="ลำดับการแสดง"
            rules={[
              {
                required: true,
                message: "Please input the Seq!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const CollectionEditServiceMenuForm = ({ visible, onEdit, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={visible}
        title="Update a LINE OA My Home Service"
        okText="Update"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onEdit(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{
            id: modalEditServiceMenu.id,
            name_en: modalEditServiceMenu.name_en,
            name_th: modalEditServiceMenu.name_th,
            alias: modalEditServiceMenu.alias,
            url: modalEditServiceMenu.url,
            logo: modalEditServiceMenu.logo,
            is_pm: modalEditServiceMenu.is_pm,
            is_rem: modalEditServiceMenu.is_rem,
            is_rental: modalEditServiceMenu.is_rental,
            seq: modalEditServiceMenu.seq,
            status: modalEditServiceMenu.status,
          }}
        >
          <Form.Item
            name="name_th"
            label="Name TH"
            rules={[
              {
                required: true,
                message: "Please input the Name TH!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="name_en"
            label="Name EN"
            rules={[
              {
                required: true,
                message: "Please input the Name EN!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="alias"
            label="Alias"
            rules={[
              {
                required: true,
                message: "Please input the Alias!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="url"
            label="Url"
            rules={[
              {
                required: true,
                message: "Please input the Url!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="logo"
            label="Logo"
            rules={[
              {
                required: true,
                message: "Please input the Logo!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Is REM"
            name="is_rem"
            rules={[
              {
                required: true,
                message: "Please input the REM!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Is PM"
            name="is_pm"
            rules={[
              {
                required: true,
                message: "Please input the PM!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Is Rental"
            name="is_rental"
            rules={[
              {
                required: true,
                message: "Please input the Rental!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value={true}>true</Radio>
              <Radio value={false}>false</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="seq"
            label="ลำดับการแสดง"
            rules={[
              {
                required: true,
                message: "Please input the Seq!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Status"
            name="status"
            rules={[
              {
                required: true,
                message: "Please input the Status!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value="Active">Active</Radio>
              <Radio value="Deactive">Deactive</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="id"
            rules={[
              {
                required: true,
                message: "Please input the Url!",
              },
            ]}
          >
            <Input hidden />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const onCreate = (values) => {
    let dataValue = {
      name_th: values.name_th,
      name_en: values.name_en,
      alias: values.alias,
      url: values.url,
      logo: values.logo,
      is_rem: values.is_rem,
      is_pm: values.is_pm,
      is_rental: values.is_rental,
      seq: values.seq,
    };
    MasterDataService.createMyHomeServiceMenu(dataValue)
      .then((data) => {
        setLoading(true);
        openNotificationWithIcon("success");
        setModalCreateServiceMenu(false);
        fetch();
      })
      .catch((err) => {
        openNotificationWithIcon("error");
        console.log("Oops errors!");
      });
  };

  const onEdit = (values) => {
    console.log(values);
    let dataValue = {
      id: values.id,
      name_th: values.name_th,
      name_en: values.name_en,
      alias: values.alias,
      url: values.url,
      logo: values.logo,
      is_rem: values.is_rem,
      is_pm: values.is_pm,
      is_rental: values.is_rental,
      seq: values.seq,
      status: values.status,
    };
    MasterDataService.editMyHomeServiceMenu(dataValue)
      .then((data) => {
        setLoading(true);
        openNotificationWithIcon("success");
        setModalEditServiceMenu({ visible: false });
        fetch();
      })
      .catch((err) => {
        openNotificationWithIcon("error");
        console.log("Oops errors!");
      });
  };

  const handleClickSort = (type, index) => {
    let data = [...state.dataSorce];
    let from = data[index];
    let to = data[type === "up" ? index - 1 : index + 1];

    data[index] = to;
    data[type === "up" ? index - 1 : index + 1] = from;
    let datachange = { menu: [] };
    for (let ii = 0; ii < data.length; ii++) {
      const element = data[ii];

      datachange.menu.push({ key: element.id, seq: ii + 1 });
    }
    console.log(datachange);
    MasterDataService.editMyHomeServiceMenuSeq(datachange)
      .then((data) => {
        setLoading(true);
        openNotificationWithIcon("success");
        setModalEditServiceMenu({ visible: false });
        fetch();
      })
      .catch((err) => {
        openNotificationWithIcon("error");
        console.log("Oops errors!");
      });
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <>
      <Space style={{ float: "right", margin: "10px" }}>
        <Button
          type="primary"
          onClick={() => setModalMultiStatus(true)}
        >
          <EditOutlined /> Change Status
        </Button>
        <Button
          type="primary"
          onClick={() => setModalCreateServiceMenu(true)}
        >
          <PlusCircleOutlined /> Create Service Menu
        </Button>
      </Space>
      <CollectionStatusForm
        key="multistatus"
        visible={modalMultiStatus}
        onCreate={onSubmitStatus}
        onCancel={() => {
          setModalMultiStatus(false);
        }}
      />
      <CollectionCreateServiceMenuForm
        key="mult"
        visible={modalCreateServiceMenu}
        onCreate={onCreate}
        onCancel={() => {
          setModalCreateServiceMenu(false);
        }}
      />
      <CollectionEditServiceMenuForm
        key="mult2"
        visible={modalEditServiceMenu.visible}
        onEdit={onEdit}
        onCancel={() => {
          setModalEditServiceMenu({ visible: false });
        }}
      />
      <Table
        rowSelection={rowSelection}
        //columns={columns}
        rowKey={(record) => record.id}
        dataSource={state.dataSorce}
        // pagination={pagination}
        loading={loading}
        // onChange={handleTableChange}
        scroll={true}
        className="table-row-pointer"
      >
        <Table.Column title="Id" dataIndex="id" />
        <Table.Column title="Name_TH" dataIndex="name_th" />
        <Table.Column title="Name_EN" dataIndex="name_en" />
        <Table.Column
          title="Url"
          dataIndex="url"
          width="120px"
          render={(text, record) => (
            <Paragraph copyable={{ text: record.url }}>{text}</Paragraph>
          )}
        />
        <Table.Column
          title="Is REM"
          align="center"
          dataIndex="is_rem"
          width="120px"
          render={(text, record) => <span>{text.toString()}</span>}
        />
        <Table.Column
          title="Is PM"
          align="center"
          dataIndex="is_pm"
          width="120px"
          render={(text, record) => <span>{text.toString()}</span>}
        />
        <Table.Column
          title="Is Rental"
          align="center"
          dataIndex="is_rental"
          width="120px"
          render={(text, record) => <span>{text.toString()}</span>}
        />
        <Table.Column
          title="Status"
          align="center"
          dataIndex="status"
          width="120px"
          render={(text, record) => (
            <Switch
              defaultChecked={text === "Active" ? true : false}
              checkedChildren="Active"
              unCheckedChildren="Deactive"
              onClick={() => showConfirmStatus(record.id, record.status)}
              //onChange={showConfirm(text.Id)}
            />
          )}
        />
        <Table.Column
          align="center"
          dataIndex="id"
          render={(text, record, index) => (
            <Space size="small">
              <Button
                size="small"
                type="link"
                disabled={index === 0}
                onClick={() => handleClickSort("up", index)}
              >
                <ArrowUpOutlined />
              </Button>
              <Button
                size="small"
                type="link"
                disabled={index + 1 === state.data?.length}
                onClick={() => handleClickSort("down", index)}
              >
                <ArrowDownOutlined />
              </Button>
              <Button
                size="small"
                type="link"
                onClick={() =>
                  setModalEditServiceMenu({
                    visible: true,
                    id: record.id,
                    name_th: record.name_th,
                    name_en: record.name_en,
                    alias: record.alias,
                    url: record.url,
                    logo: record.logo,
                    is_pm: record.is_pm,
                    is_rem: record.is_rem,
                    is_rental: record.is_rental,
                    seq: record.seq,
                    status: record.status,
                  })
                }
              >
                แก้ไข
              </Button>
              <Button
                size="small"
                type="link"
                onClick={() => showConfirmDelete(record.id, record.status)}
              >
                ลบ
              </Button>
            </Space>
          )}
        />
      </Table>
    </>
  );
}
// ••••••••••••••••••••

const openNotificationWithIcon = (type) => {
  if (type === "success") {
    notification[type]({
      message: "Success",
      description: "Successfully.",
    });
  } else {
    notification[type]({
      message: "Error",
      description: "Something when wrong.",
    });
  }
};

export default TableMyHomeMenu;
